"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../../../lib/utils");

var _loveIconActiveNew = _interopRequireDefault(require("../../../../images/shared/icons/love-icon-active-new.png"));

var _loveIconInactiveNew = _interopRequireDefault(require("../../../../images/shared/icons/love-icon-inactive-new.png"));

var _commentIconNew = _interopRequireDefault(require("../../../../images/shared/icons/comment-icon-new.png"));

require("./LikesCommentsBlock.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LikesCommentsBlock = function LikesCommentsBlock(_ref) {
  var _ref$likes = _ref.likes,
      likes = _ref$likes === void 0 ? [] : _ref$likes,
      isLiked = _ref.isLiked,
      _ref$commentsCount = _ref.commentsCount,
      commentsCount = _ref$commentsCount === void 0 ? 0 : _ref$commentsCount,
      _ref$handleCommentsCo = _ref.handleCommentsCountClick,
      handleCommentsCountClick = _ref$handleCommentsCo === void 0 ? function () {} : _ref$handleCommentsCo,
      handleLove = _ref.handleLove;
  var likesCount = likes === null || likes === void 0 ? void 0 : likes.length;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "comments-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "comments-block-likes",
    onClick: handleLove
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isLiked ? _loveIconActiveNew.default : _loveIconInactiveNew.default,
    alt: "love inactive"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "likes-text"
  }, likesCount, " Love", likesCount === 1 ? '' : 's')), /*#__PURE__*/_react.default.createElement("div", {
    className: "comments"
  }, !!commentsCount && /*#__PURE__*/_react.default.createElement("div", {
    className: "comments-count-container",
    onClick: function onClick() {
      (0, _utils.googleAnalytics)('comments_count')();
      handleCommentsCountClick();
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "comments-image",
    src: _commentIconNew.default,
    alt: "CommentInactive"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "comments-count"
  }, commentsCount))));
};

var array = _propTypes.default.array,
    bool = _propTypes.default.bool,
    func = _propTypes.default.func,
    number = _propTypes.default.number;
LikesCommentsBlock.propTypes = {
  likes: array,
  isLiked: bool.isRequired,
  commentsCount: number,
  handleCommentsCountClick: func,
  handleLove: func.isRequired
};
var _default = LikesCommentsBlock;
exports.default = _default;